import React from 'react';
import PropTypes from 'prop-types';
import { Check } from 'lucide-react';

/**
 * Runder Ziel-Haken wie im Spot (Motion-Kit `.eo-check`): Beim Abhaken waechst
 * die lila Fuellung federnd aus der Mitte, dann erscheint der Haken. Bei
 * „Bewegung reduzieren“ greift der globale Schalter in App.css.
 *
 * Nur die Optik — Knopf und Beschriftung liefert die Zeile.
 */
const GoalCheck = ({ completed, size = 'md' }) => {
  const box = size === 'sm' ? 'h-5 w-5' : 'h-6 w-6';
  const icon = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';
  return (
    <span
      className={`relative flex ${box} shrink-0 items-center justify-center rounded-full border-2 ${
        completed ? 'border-primary' : 'border-border group-hover:border-primary/60'
      } transition-colors duration-fast`}
      aria-hidden="true"
    >
      <span
        className={[
          'absolute -inset-[2px] rounded-full bg-primary transition-transform duration-base ease-spring',
          completed ? 'scale-100' : 'scale-0',
        ].join(' ')}
      />
      <Check
        className={[
          `relative ${icon} text-primary-foreground transition-opacity duration-fast`,
          completed ? 'opacity-100 delay-100' : 'opacity-0',
        ].join(' ')}
        strokeWidth={3}
      />
    </span>
  );
};

GoalCheck.propTypes = {
  completed: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default GoalCheck;
